import { useDispatch, useSelector } from "react-redux";
import { mdmsProp } from "../redux-store/reducers/mdmsData";
import { RootStateType } from "../redux-store/reducers";
import { useEffect } from "react";
import { featureToggles } from "../redux-store/actions";

export const useFeatureToggles = (): mdmsProp => {
  const dispatch = useDispatch();
  const mdmsData = useSelector((state: RootStateType) => state.mdmsDataReducer);

  useEffect(() => {
    (async function () {
      try {
        const shouldFetch = Object.values(mdmsData.toggler.dateFeatureToggles).some(
          (date) => !date
        );
        if (shouldFetch) {
          await dispatch(featureToggles());
        }
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [mdmsData.toggler, dispatch]);

  return mdmsData;
};
